function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#popularity_svg__clip0_1_70)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.263 8.647C10.406 5.671 9.64.841 4.053 0c.689 1.3 2.067 3.52-2.51 7.27-2.057 1.902-1.847 4.143-.598 5.823 1.113 1.497 3.282 1.792 4.945 2.52-2.43-2.891.23-3.99 2.373-6.966z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.453 15.612c.5-1.562 6.092-.265 3.121-7.764-.5 1.761-1.832 2.971-2.869 4.317-1.038 1.347-.742 2.17-.252 3.447z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "popularity_svg__clip0_1_70"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h11v16H0z"
})));

function SvgPopularity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgPopularity;